
<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('activity.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>


            <div class="card row">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('activity.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row mt-2">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.activity') }}</label>
                            <dropdown :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.ActivityType"
                                      v-model="activity.typeId"
                                      :required="true"
                                      @change="getSubType1"
                                      :fieldName="$t('activity.type')"></dropdown>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="subType2Count>0">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.subActivity') }}</label>
                            <dropdown :type="subType1"
                                      v-model="activity.subType1Id"
                                      :required="true"
                                      @change="getSubType2"
                                      :fieldName="$t('activity.type')"></dropdown>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="subType3Count > 0">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.direction') }}</label>
                            <dropdown :type="subType2"
                                      @change="getSubType3"
                                      v-model="activity.subType2Id"
                                      :required="true"
                                      :fieldName="$t('activity.type')"></dropdown>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="subType4Count>0">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.subDirection') }}</label>
                            <dropdown :type="subType3"
                                      v-model="activity.subType3Id"
                                      :required="true"
                                      :fieldName="$t('activity.type')"></dropdown>
                        </div>
                    </div>
                </div>
            </div>

            <AuxiliaryRegister ref="auxiliaryRegisterRef"
                               :register-id="AuxiliaryRegisters.Activities_Directions"
                               register-name="Activity"
                               :entry-id="activity.auxRegisterEntityId"></AuxiliaryRegister>

        </div>

        <div class="text-center mt-2 mb-5">
            <button type="button" class="btn btn-primary btn" @click="onSubmit">
                <i class="fas fa-save"></i>
                {{ $t('buttons.save.btnText') }}
            </button>
        </div>
    </form>
</template>

<script>
    import Dropdown from '../../../components/dropdown/NomenclatureDropdown';
    import { Activity } from '@/models/models';
    import PageTitle from '../../../components/common/PageTitle';
    import { NomenclatureParentBySort, AuxiliaryRegisters } from '@/models/enums';
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        components: {
            Dropdown,
            PageTitle,
            AuxiliaryRegister
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: null,
                isMountingSubType1: true,
                isMountingSubType2: true,
                isMountingSubType3: true,
                activity: new Activity(),
                loading: false,
                subType1: '',
                subType2: '',
                subType3: '',
                subType2Count: 0,
                subType3Count: 0,
                subType4Count: 0,
                isSaved: false,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.activity.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                })
            },
            backToRegister() {
                this.$router.push('/registers/activities');
            },
            create() {
                this.loading = true;
                this.$http.post('/api/activity', this.activity).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/activity', this.activity).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'), // TODO:
                        text: this.$t('notifications.successfulSavedData'), // TODO:
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/activity/${this.id}`).then(result => {
                    this.activity = new Activity(result.data);
                    this.$store.initialModel = _.cloneDeep(this.activity);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            },
            getSubType1(typeId) {
                if (!this.isMountingSubType1) {
                    this.activity.subType1Id = '';
                    this.activity.subType2Id = '';
                    this.activity.subType3Id = '';
                }
                this.$http.get(`/api/search/${typeId}`).then(result => {
                    this.subType1 = result.data.text;
                    this.$http.get(`/api/search/GetNomenclatureItems?type=${this.subType1}`).then(result => {
                        this.subType2Count = result.data.length;
                        this.subType3Count = 0;
                        this.subType4Count = 0;
                        this.isMountingSubType1 = false;
                    });
                });
            },
            getSubType2(typeId) {
                if (!this.isMountingSubType2) {
                    this.activity.subType2Id = '';
                    this.activity.subType3Id = '';
                }
                this.$http.get(`/api/search/${typeId}`).then(result => {
                    this.subType2 = result.data.text;
                    this.$http.get(`/api/search/GetNomenclatureItems?type=${this.subType2}`).then(result => {
                        this.subType3Count = result.data.length;
                        this.subType4Count = 0;
                        this.isMountingSubType2 = false;
                    });
                });
            },
            getSubType3(typeId) {
                if (!this.isMountingSubType3) {
                    this.activity.subType3Id = '';
                }
                this.$http.get(`/api/search/${typeId}`).then(result => {
                    this.subType3 = result.data.text;
                    this.$http.get(`/api/search/GetNomenclatureItems?type=${this.subType3}`).then(result => {
                        this.subType4Count = result.data.length;
                        this.isMountingSubType3 = false;
                    });
                });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
            this.$store.initialModel = _.cloneDeep(this.activity);
        },
        beforeRouteLeave(to, from, next) {
            if (!_.isEqual(this.$store.initialModel, this.activity) && !this.isSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }
        },
    }
</script>

<style scoped>
</style>
